import { render, staticRenderFns } from "./NewEditorialModal.vue?vue&type=template&id=2db45139&scoped=true"
import script from "./NewEditorialModal.vue?vue&type=script&lang=js"
export * from "./NewEditorialModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db45139",
  null
  
)

export default component.exports